<template>
  <main id="error">
      <img src="@/assets/human-error.jpeg" alt="error">
      <h1>It seems something went horrible wrong!</h1>
      <h2>{{ msg }}</h2>
      <router-link to="/" class="btn outline">Try again</router-link>
  </main>
</template>

<script>
export default {
    name: 'Error',
    computed:{
        msg(){
            return this.$store.state.errorMsg;
        }
    }
}
</script>

<style lang="scss">
@import './../scss/variables';

#error {
    background: $darkRed;
    color: white;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 1rem;
    box-sizing: border-box;

    img {
        max-width: 25rem;
        width: 100%;
        margin: 1rem 0;
    }

    h1 {
        text-align: center;
    }

    h2 {
        margin: 0;
        font-weight: 400;
        text-align: center;
    }

    .btn {
        margin-top: 2rem;
        border-color: white;
        color: #222;
        text-decoration: none;
    }
}
</style>